export default __webpack_public_path__ + "static/media/GuildHall_tmb.c2c68468.jpg";